import React, { Component } from 'react';
const $=window.$;
const win=window;

class Bookaccordian extends Component{

  constructor(props) {
    super(props);
    this.state = {};

        this.container="";
        this.bookBlock="";
        this.items="";
        this.itemsCount = 0;
        this.current = 0;
        this.bb="";
        this.navNext = "";
        this.navPrev ="";
        this.menuItems = "";
        this.tblcontents = "";
        this.transEndEventNames="";
        this.transEndEventName="";
        this.supportTransitions ="";
  }

  componentDidMount() {
   setTimeout(()=>{

       let self=this;
       self.container = $('#'+this.refs.bookContainer.id);
       self.bookBlock = $('#'+this.refs.bookBlock.id);
       self.items = self.bookBlock.children();
       self.itemsCount = self.items.length;
       self.current = 0;
       self.bb = $('#'+this.refs.bookBlock.id).bookblock( {
        speed : 800,
        perspective : 2000,
        shadowSides	: 0.8,
        shadowFlip	: 0.4,
        onEndFlip : function(old, page, isLimit) {

         self.current = page;

         // update TOC current
         self.updateTOC();
         // updateNavigation
         self.updateNavigation( isLimit );

         // initialize jScrollPane on the content div for the new item
         self.setJSP( 'init' );
         // destroy jScrollPane on the content div for the old item
         self.setJSP( 'destroy', old );

        }
       } );

       self.navNext = $( '#bb-nav-next' );
       self.navPrev = $( '#bb-nav-prev' ).hide();
       self.menuItems = self.container.find( 'ul.menu-toc > li' );
       self.tblcontents = $( '#tblcontents' );
       self.transEndEventNames = {
        'WebkitTransition': 'webkitTransitionEnd',
        'MozTransition': 'transitionend',
        'OTransition': 'oTransitionEnd',
        'msTransition': 'MSTransitionEnd',
        'transition': 'transitionend'
       };
       self.transEndEventName = self.transEndEventNames[win.Modernizr.prefixed('transition')];

       self.supportTransitions = win.Modernizr.csstransitions;

       self.setJSP( 'init' );
     		self.initEvents();
    },500);

  }


  initEvents() {

   let self=this;
 		// add navigation events
 		self.navNext.on( 'click', function() {



 		self.bb.next();
 			return false;
 		} );

 		self.navPrev.on( 'click', function() {

 		self.bb.prev();
 			return false;
 		} );

 		// add swipe events
 		self.items.on( {
 			'swipeleft'		: function( event ) {
 				if( self.container.data( 'opened' ) ) {
 					return false;
 				}
 			self.bb.next();
 				return false;
 			},
 			'swiperight'	: function( event ) {
 				if( self.container.data( 'opened' ) ) {
 					return false;
 				}
 				self.bb.prev();
 				return false;
 			}
 		} );

 		// show table of contents
 		self.tblcontents.on( 'click', self.toggleTOC );

 		// click a menu item
 		self.menuItems.on( 'click', function() {



 			var $el = $( this ),
 				idx = $el.index(),
 				jump = function() {
 					self.bb.jump( idx + 1 );
 				};

 			this.current !== idx ? self.closeTOC( jump ) : self.closeTOC();

 			return false;

 		} );

 		// reinit jScrollPane on window resize
 		$( win ).on( 'debouncedresize', function() {
 			// reinitialise jScrollPane on the content div
 			self.setJSP( 'reinit' );
 		} );

 	}


  setJSP( action, idx ) {
   let self=this;
 		var idx = idx === undefined ? self.current : idx,
 			$content = self.items.eq( idx ).children( 'div.content' ),
 			apiJSP = $content.data( 'jsp' );

 		if( action === 'init' && apiJSP === undefined ) {

 			$content.jScrollPane({verticalGutter : 0, hideFocus : true });
 		}
 		else if( action === 'reinit' && apiJSP !== undefined ) {
 			apiJSP.reinitialise();
 		}
 		else if( action === 'destroy' && apiJSP !== undefined ) {
 			apiJSP.destroy();
 		}

 	}

  updateTOC() {
   this.menuItems.removeClass( 'menu-toc-current' ).eq( this.current ).addClass( 'menu-toc-current' );
  }

  updateNavigation( isLastPage ) {

 		if( this.current === 0 ) {
 			this.navNext.show();
 			this.navPrev.hide();
 		}
 		else if( isLastPage ) {
 			this.navNext.hide();
 			this.navPrev.show();
 		}
 		else {
 			this.navNext.show();
 			this.navPrev.show();
 		}

 	}


 toggleTOC() {
 		var opened = this.container.data( 'opened' );
 		opened ? this.closeTOC() : this.openTOC();
 	}

 openTOC() {
 		this.navNext.hide();
 		this.navPrev.hide();
 		this.container.addClass( 'slideRight' ).data( 'opened', true );
 	}


  closeTOC( callback ) {
   let self=this;
   self.updateNavigation( self.current === self.itemsCount - 1 );
   self.container.removeClass( 'slideRight' ).data( 'opened', false );
   if( callback ) {
    if( self.supportTransitions ) {
     self.container.on( self.transEndEventName, function() {
      $( this ).off( self.transEndEventName );
      callback.call();
     } );
    }
    else {
     callback.call();
    }
   }

  }



  render() {
    const {shows}=this.props;

    return (
     <div id="container" ref="bookContainer" className="container-dairy">
     <div className="bb-custom-wrapper">
   <div className="bb-bookblock" id="bb-bookblock" ref="bookBlock">



   {shows.length>0 &&

     shows.map((key,index)=>{
       return <div key={`s_wise${index}`} className="bb-item" id={`item${index}`} style={{display:index==0?'block':'none'}}>
       <div className="content" >
       <div className="scroller">
       <div className="pagetitle" >{key['pagetitle']}</div>
       <h2 className="pagetitle1" dangerouslySetInnerHTML={{ __html:key['pagetitle1']?key['pagetitle1']:''}} />
       <div className="pagedate">{key['pagedate']}</div>
       <div className="clear"></div>
       <span className="scroller_new" dangerouslySetInnerHTML={{ __html:key['notes']?key['notes']:''}} />
       </div>
       </div>
       </div>
    })

   }

   {shows.length==0 &&
    <div className="bb-item" id="item0">
            <div className="content">
             <div className="scroller">
              <div className="timebox_new"><span className="red-txt">No Notes</span></div>
              </div>
             </div>
            </div>
   }




   </div>

   <nav>
    <span id="bb-nav-prev" style={{display: 'none'}}>&lt;</span>
         <span id="bb-nav-next">&gt;</span>
        </nav>

   <span className="menu-button" id="tblleftcontents">Table of Contents</span>

     </div>
  	 </div>
    );
  }

}
export default Bookaccordian;



// WEBPACK FOOTER //
// ./src/components/Bookaccordian.js